import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const PressureWashing = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my pressure washing business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps pressure washing businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for pressure washing businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most pressure washing businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my pressure washing business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like pressure washing. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Pressure Washing - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Pressure Washing CRM", url: "/industries/pressure-washing" }
  ];

  const industryData = {
    name: 'Pressure Washing',
    title: 'Book More Jobs & Convert to Annual Maintenance Contracts',
    subtitle: 'Automate seasonal reminders, capture booking requests 24/7, and build recurring commercial revenue',
    icon: '💦',
    challenges: [
      'Seasonal business with income gaps',
      'One-time customers never return',
      'Hard to get commercial contracts',
      'Weather delays cause rescheduling chaos',
      'Difficult to estimate without seeing property'
    ],
    solutions: [
      'Automated annual reminder campaigns',
      'Recurring service plan automation',
      'Commercial client nurture sequences',
      'Weather-based rescheduling',
      'Aerial/photo-based estimates'
    ],
    features: [
      'Client CRM with service tracking',
      'Seasonal marketing automation',
      'Commercial contract management',
      'Weather notifications',
      'Online estimate calculator',
      'Before/after galleries',
      'Recurring service automation',
      'Review requests'
    ],
    results: [
      '65% residential become annual clients',
      '5x more commercial contracts',
      'Consistent year-round bookings',
      '£4.8K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Pressure Washing UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for pressure washing businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for pressure washing UK, pressure washing business software, pressure washing customer management, pressure washing lead generation UK"
        url="/industries/pressure-washing"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default PressureWashing;